import Router from "next/router";
import { useAuth } from "./auth";

export function withAuth(WrappedComponent) {
  function Wrapper(props) {
    const { loading, isAuthenticated, getTokenSilently } = useAuth();
    if (loading) return null;
    if (!isAuthenticated) {
      Router.push("/login");
      return null;
    }
    return <WrappedComponent getTokenSilently={getTokenSilently} {...props} />;
  }
  if (WrappedComponent.getInitialProps) {
    Wrapper.getInitialProps = async ctx => {
      const componentProps =
        WrappedComponent.getInitialProps && (await WrappedComponent.getInitialProps(ctx));

      return { ...componentProps };
    };
  }
  return Wrapper;
}

export default withAuth;
